import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  apUid: Yup.string()
    .required("Name is required"),
  comparisons: Yup.array().min(1, 'At least one comparison is required.')
})